import React from 'react';
import Navbar from './Navbar';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Landing.css'
function ContactUs() {
    function submitClicked() {

        alert("Thanks for your Message.");
        window.location.href = '/home';
    }
    return (
        <>
            <Navbar />
            <section id="contact" className="contact-section">
                <Container>
                    <h2 className="text-center mb-5">Contact Us</h2>
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <Form>
                                <Form.Group controlId="formName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter your name" />
                                </Form.Group>
                                <Form.Group controlId="formEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control type="email" placeholder="Enter your email" />
                                </Form.Group>
                                <Form.Group controlId="formMessage">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control as="textarea" rows={4} placeholder="Enter your message" />
                                </Form.Group>
                                <Button variant="primary" type="submit" onClick={submitClicked}>
                                    Submit
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default ContactUs;
